import { useEffect, useState } from 'react'
import { Empty } from 'antd'
import PaymentService from '../../../../services/paymentService'
import { useAppParamsContext } from '../../../../context/AppParamsContext'
import { usePartnerStrategy } from '../../../../hooks/payment/partner'
import SafeImage from '../../../../components/BasicComponent/SafeImage'
import bidvRegistrationEmptyVehicleImage from '../../../../assets/images/BIDV/registration_empty_vehicle.png'
import useThemeFeatureConfig from '../../../../hooks/common/useThemeFeatureConfig'
import './index.scss'

export default function AutoTrafficFinePayment({ paymentMethod, setPaymentMethod, hideUi }) {
  const { paymentMethodType, apikey, appThemeName } = useAppParamsContext()
  const { paymentMethodEmptyStateVariant = 1 } = useThemeFeatureConfig('AUTOMATED_TRAFFIC_FINE_NOTIFICATION_PAYMENT')
  const partnerStrategy = usePartnerStrategy()
  const [listPaymentMethod, setListPaymentMethod] = useState({})

  useEffect(() => {
    let isMounted = true

    async function fetchPaymentMethods() {
      try {
        const payload = partnerStrategy.getPaymentMethodApiPayload({ apikey })
        const response = await PaymentService.getPaymentQRMethod(payload)

        if (!isMounted || !response || typeof response !== 'object') {
          return
        }

        const rawData = Object.values(response)
        const { filteredData, initialMethod } = partnerStrategy.processPaymentMethods(rawData, paymentMethodType, appThemeName)

        const dataConverted = Object.fromEntries(filteredData.map((item) => [item.paymentMethodId, item]))

        if (initialMethod) {
          setPaymentMethod(initialMethod)
        }
        setListPaymentMethod(dataConverted)
      } catch {
        // Lỗi mạng / API: hiển thị Empty state.
        if (isMounted) {
          setListPaymentMethod({})
        }
      }
    }

    fetchPaymentMethods()

    return () => {
      isMounted = false
    }
  }, [paymentMethodType, apikey, setPaymentMethod, partnerStrategy])

  const paymentMethodKeys = Object.keys(listPaymentMethod)
  const onlyOneMethod = paymentMethodKeys.length === 1

  if (hideUi) {
    return null
  }

  return (
    <div className="autoTrafficFinePayment">
      <div className="autoTrafficFinePayment_paymentMethodSection">
        <div className="section-title">Phương Thức Thanh Toán</div>
        <div style={{ color: 'var(--text-secondary)', fontSize: '14px', lineHeight: '1.5', fontWeight: 400 }}>Vui lòng chọn 1 hình thức</div>
        {paymentMethodKeys.length > 0 ? (
          <div className="payment-method-grid">
            {paymentMethodKeys.map((key) => {
              const method = listPaymentMethod[key]
              const isActive = +paymentMethod?.paymentMethodId === +key

              return (
                <div
                  key={key}
                  onClick={() => setPaymentMethod(method)}
                  className={`payment-method-item ${isActive ? 'active' : ''} ${onlyOneMethod ? 'w-100' : ''}`.trim()}>
                  <SafeImage height={30} src={method?.paymentMethodImageUrl} style={{ marginBottom: '8px' }} />
                  <div className="payment-method-name">{method.paymentMethodName || key}</div>
                </div>
              )
            })}
          </div>
        ) : paymentMethodEmptyStateVariant === 2 ? (
          <div className="autoTrafficFinePayment_emptyBidv">
            <SafeImage
              src={bidvRegistrationEmptyVehicleImage}
              className="autoTrafficFinePayment_emptyBidvImage"
              aria-hidden="true"
            />

            <div className="autoTrafficFinePayment_emptyBidvText">
              Không có phương thức thanh toán
            </div>
          </div>
        ) : (
          <Empty description="Không có phương thức thanh toán" />
        )}
      </div>
    </div>
  )
}
